import { render, staticRenderFns } from "./NetworkGateway.vue?vue&type=template&id=0451cc50&scoped=true"
import script from "./NetworkGateway.vue?vue&type=script&lang=js"
export * from "./NetworkGateway.vue?vue&type=script&lang=js"
import style0 from "./NetworkGateway.vue?vue&type=style&index=0&id=0451cc50&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0451cc50",
  null
  
)

export default component.exports